import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';

const OrderHistoryView = ({ reactTableData, isNoRecordFound, isTotalCount, isPageSize, isTotalPages }) => {
  const rows = reactTableData && reactTableData?.tableRowsData ? reactTableData.tableRowsData : null;
  const { t } = useTranslation('common');
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Order No., Invoice No.,etc',
  };

  // Function to handle next page click
  return (
    <div className="trip-history-table">
      {!isNoRecordFound && rows && (
        <ReactTableBase
          name={t('Trip History')}
          key={'searchable'}
          columns={reactTableData.tableHeaderData}
          data={rows}
          tableConfig={tableConfig}
          isTotalCount={isTotalCount}
          isPageSize={isPageSize}
          isTotalPages={isTotalPages}
        />
      )}
    </div>
  );
};

OrderHistoryView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default OrderHistoryView;

